import React, { useState, useEffect } from "react";
import { Box, TextField, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import styles from "../../../../styles/gri/general.module.css";
import { put, get } from "../../../../utils/api";
import EastIcon from "@mui/icons-material/East";
import GRISidebar from "../../../../Layout/GRISidebar";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

export default function GRI306_1({ hide }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [formData, setFormData] = useState({
    wasteRelatedImpacts: "",
    impactInputsActivitiesOutputs: "",
    wasteImpactScope: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    setFormData((prev) => {
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: value,
          },
        };
      } else {
        return { ...prev, [main]: value };
      }
    });
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GRI300&Id=${id}`).then((res) => {
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const response = res?.data?.data?.GRI300?.wasteRelatedImpact;
      setFormData({
        wasteRelatedImpacts: response?.wasteRelatedImpacts,
        impactInputsActivitiesOutputs: response?.impactInputsActivitiesOutputs,
        wasteImpactScope: response?.wasteImpactScope,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      try {
        await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          wasteRelatedImpact: { ...formData },
          submitted306_1: true,
        })
          .then((res) => navigate(`/gri/gri300/306-2/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/306-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p
        className={styles.section_heading}
        style={{ marginBottom: hide ? "-1rem" : "1rem" }}
      >
        306 : Waste
      </p>}
      <p
        className={styles.main_heading}
        style={{
          // marginTop: "2.5rem",

          marginBottom: hide ? "-1rem" : "0.5rem",
          display: "flex",
        }}
      >
        306-1: Waste generation and significant waste-related impacts
      </p>

      <Box>
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",

            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          a. Describe the organization’s significant actual and potential
          waste-related impacts:
        </p>

        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ padding: " 0px 18px" }}
          name={`wasteRelatedImpacts`}
          value={formData?.wasteRelatedImpacts}
          onChange={handleChange}
          //   error={errors.totalRecycled}
          disabled={disabled}
        />
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",
            marginRight: "1rem",
            marginLeft: "1rem",
            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          i. The inputs, activities, and outputs that lead or could lead to
          these impacts.
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ padding: " 0px 24px", marginLeft: "0.5rem" }}
          name={`impactInputsActivitiesOutputs`}
          value={formData?.impactInputsActivitiesOutputs}
          onChange={handleChange}
          //   error={errors.totalRecycled}
          disabled={disabled}
        />
        <p
          className={styles.ques_heading}
          style={{
            // marginTop: "2.5rem",
            marginRight: "1rem",
            marginLeft: "1rem",
            marginBottom: "0.5rem",
            display: "flex",
          }}
        >
          ii. Do these impacts relate to waste generated in the organization’s
          own activities or to waste generated upstream or downstream in its
          value chain?
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ padding: " 0px 24px", marginLeft: "0.5rem" }}
          name={`wasteImpactScope`}
          value={formData?.wasteImpactScope}
          onChange={handleChange}
          //   error={errors.totalRecycled}
          disabled={disabled}
        />
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
}
